<template>
  <!-- 公共弹窗 -->
  <a-drawer
    :visible="isVisible"
    :width="drawerWidth"
    :closable="false"
    :destroyOnClose="true"
    :get-container="false"
    :wrap-style="{ position: 'absolute' }"
    class="drawer"
    @close="handleCancel"
  >
    <template slot="title">
      <div style="display:flex; position: relative;">
        <a-button v-if="buttons" type="primary" icon="login" @click="goNoteClick">返回</a-button>
        <div style="margin-left: 20px; font-size: 18px !important;">[查看]-{{ titles }}</div>
        <!-- <span @click="handleCancel" class="close" style=""><a-icon type="close"/> 关闭</span> -->
        <span class="edit">
          <a-button
            v-if="drawerWidthFlag"
            type="primary"
            icon="fullscreen"
            size="default"
            @click="setDrawerWidth(false)"
          />
          <a-button
            v-if="!drawerWidthFlag"
            type="primary"
            icon="fullscreen-exit"
            size="default"
            @click="setDrawerWidth(true)"
          />
          <a-button
            v-hasPermission="'log:view'"
            type="primary"
            icon="eye"
            @click="logClick"
            v-if="titles !== '资产统计'"
          >日志</a-button>
          <a-button
            v-hasPermission="'log:saleView'"
            type="primary"
            icon="eye"
            @click="logClick"
            v-if="isLog === true"
          >日志</a-button>
          <a-button
            v-if="isShows"
            v-show="isButtonShow"
            type="primary"
            icon="edit"
            @click="handleEdit"
          >编辑</a-button>
          <!-- 在按钮附近添加调试信息 -->
          <!-- <div style="position: absolute; right: 250px; color: #666">
    当前isLog状态: {{ JSON.stringify(isLog) }}
          </div>-->
        </span>
        <a-button class="close" icon="close" @click="handleCancel">关闭</a-button>
      </div>
    </template>
    <div v-show="loadings">
      <a-spin tip="Loading..." style="height: 400px;">
        <div class="spin-content"></div>
      </a-spin>
    </div>
    <div v-show="!loadings">
      <component
        :isChild="true"
        :is="getName"
        @onClickView="onLoadView"
        ref="componentRef"
        @datasChange="datasChange"
        @projectChange="projectChange"
        @largeOrExpenseChange="detailClickOutwork"
        @detailClickhuman="detailClickOutwork"
        @detailClickOutwork="detailClickOutwork"
      />
    </div>
    <public-edit-dialog
      :title="publicDias.title"
      ref="publicEditDialogRef"
      :dialog-visible="publicDias.visible"
      :component-name="publicDias.comName"
      @logSuccess="publicDialogSucc"
      @handleSuccuse="handleSuccuse"
      @cancel="publicDialogCancel"
    ></public-edit-dialog>
    <public-log-dialog
      :title="publicLogDias.title"
      ref="publicLogDiasRef"
      :dialog-visible="publicLogDias.visible"
      @logSuccess="publicLogDiasSucc"
      @cancel="publicLogDiasCancel"
    ></public-log-dialog>
  </a-drawer>
</template>

<script>
import supplierManage from '@/views/purchase/supplier/index.vue'
import publicEditDialog from '@/components/modelDialog/publicEditDialog.vue'
import publicLogDialog from '@/components/modelDialog/publicLogDialog.vue'
export default {
  name: 'PublicDialog',
  components: {
    supplierManage,
    publicEditDialog,
    publicLogDialog
  },
  props: {
    componentName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '选择信息'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentNames) {
        return (resolve) => require([`@/views/${this.componentNames}`], resolve)
      }
      return null
    }
  },
  data () {
    return {
      publicLogDias: {
        title: '',
        visible: false
      },
      drawerWidth: '65%',
      drawerWidthFlag: true,
      recycleBinShow: 0,
      nowUserName: this.$db.get('USER').username,
      publicDias: {
        title: '',
        visible: false,
        comName: ''
      },
      isButtonShow: true,
      chooseData: '',
      form: {},
      buttons: true,
      titles: this.title,
      componentNames: this.componentName,
      authNames: [],
      arr: [],
      loadings: true,
      isLog: null, // 销售资源池/待办任务/销售机会单独添加日志权限按钮
      isShows: this.isShow,
      authList: this.$db.get('PERMISSIONS')
    }
  },
  watch: {
    isVisible (newVal, oldVal) {
      if (newVal) {
        if (this.arr.length <= 1) {
        }
      } else {
        this.arr = []
      }
    },
    arr (newVal, oldVal) {
      if (newVal.length <= 1) {
        this.buttons = false
      } else this.buttons = true
    }
  },
  methods: {
    setDrawerWidth (e) {
      // console.log('setDrawerWidth')
      this.drawerWidthFlag = e
      if (e) {
        this.drawerWidth = '65%'
      } else {
        this.drawerWidth = '100%'
      }
    },
    changeLog (e) {
      this.$nextTick(() => {
        const newValue = !!e
        if (this.isLog !== newValue) {
          this.isLog = newValue
          // console.log('[DEBUG] 状态更新生效',
          //   `接收参数:${e}`,
          //   `转换后:${newValue}`,
          //   `当前类型:${typeof newValue}`
          // )
        }
      })
    },
    logClick () {
      // console.log(this.titles, this.componentNames, 1234)
      switch (this.titles) {
        case this.$tree([], 'financialManage/prepayment/index'):
        case this.$tree([], 'financialManage/advance/index'):
        case '预支预付':
          this.goLog('prePayment')
          break
        case this.$tree([], 'assetInformation/assetRegistration/index'):
          this.goLog('fixAssetManagement')
          break
        case this.$tree([], 'financialManage/expenseReim/index'):
          this.goLog('reimbursement')
          break
        case this.$tree([], 'purchase/purchaseRequest/index'):
          this.goLog('purchaseRequisition')
          break
        case this.$tree([], 'financialManage/ticketReceiptRecord/index'):
        case this.$tree([], 'financialManage/billingRecords/index'):
          this.goLog('invoice')
          break
        case this.$tree([], 'contractManage/paymentPlan/index'):
        case this.$tree([], 'contractManage/paymentRecord/index'):
          this.goLog('payBack')
          break
        case this.$tree([], 'purchase/paymentSchedule/index'):
        case this.$tree([], 'purchase/paymentRecords/index'):
          this.goLog('payPlan')
          break
        case this.$tree([], 'offices/courtesyApplication/index'): // 1
          this.goLog('festivalGift')
          break
        case this.$tree([], 'system/notice/index'):
          this.goLog('notice')
          break
        case this.$tree([], 'financialManage/largeAmountApplication/index'):
          this.goLog('bigAmount')
          break
        case this.$tree([], 'purchase/supplier/supplierLink/index'):
        case this.$tree([], 'customerManage/linkName/index'):
          this.goLog('linkman')
          break
        case this.$tree([], 'projectManage/humanCost/index'):
          this.goLog('humanCost')
          break
        case this.$tree([], 'projectManage/projectProposals/index'):
          this.goLog('projectApproval')
          break
        case this.$tree([], 'purchase/productManage/index'):
          this.goLog('product')
          break
        case this.$tree([], 'projectManage/fundCost/index'):
          this.goLog('fundCost')
          break
        case this.$tree([], 'offices/operatingCosts/index'):
          this.goLog('operatingCosts')
          break
        case this.$tree([], 'projectManage/laborAndMaterial/index'):
          this.goLog('projectReporting')
          break
        case this.$tree([], 'inventory/transferWarehouses/index'):
          this.goLog('stockAllot')
          break
        case this.$tree([], 'inventory/outStock/index'):
        case `${this.$tree([], 'inventory/outStock/index')}详情`:
          this.goLog('stockOut')
          break
        case this.$tree([], 'inventory/informationSettings/index'):
          this.goLog('stock')
          break
        case this.$tree([], 'inventory/takeItBack/index'):
          this.goLog('stockReceive')
          break
        case this.$tree([], 'inventory/storageReceipt/index'):
          this.goLog('stockIn')
          break
        case this.$tree([], 'offices/travelRecords/index'):
          this.goLog('outwork')
          break
        case this.$tree([], 'offices/overtimeRecords/index'):
          this.goLog('workOverTime')
          break
        case this.$tree([], 'customerManage/resignationsLinkName/index'):
          this.goLog('linkman')
          break
        case this.$tree([], 'customerManage/resignationsCompensation/index'):
          this.goLog('customer')
          break
        case this.$tree([], 'purchase/purchRefundRec/index'):
          this.goLog('payRefund')
          break
        case this.$tree([], 'inventory/prodTransRec/index'):
          this.goLog('projectCarryOver')
          break
        case this.$tree([], 'inventory/returnWarehouse/index'):
          this.goLog('stockToback')
          break
        case this.$tree([], 'contractManage/contractManagement/index'):
          this.goLog('contractSupplement')
          break
        case '销售资源':
          this.goLog('saleResource')
          break
        case this.$tree([], 'salesOpportunities/todoTask/index'):
          this.goLog('saleTask')
          break
        case this.$tree([], 'salesOpportunities/projectOpportunities/index'):
          this.goLog('saleOpportunity')
          break
        case this.$tree([], 'manpower/recruitmentDemand/index'):
          this.goLog('recruitment')
          break
        case this.$tree([], 'contractManage/earnestMoney/index'):
          this.goLog('performanceBond')
          break
        case this.$tree([], 'offices/vehicleDepartureRecord/index'):
          this.goLog('outCar')
          break
        case this.$tree([], 'offices/returnCarRecord/index'):
          this.goLog('returnCar')
          break
        default:
          break
      }
      switch (this.componentNames) {
        case 'financialManage/billingRecords/viewBill.vue':
          this.goLog('invoice')
          break
        case 'financialManage/ticketReceiptRecord/viewCollection.vue':
          this.goLog('invoice')
          break
        case 'customerManage/linkName/show.vue':
          this.goLog('linkman')
          break
        case 'inventory/takeItBack/details.vue':
          this.goLog('stockReceive')
          break
        // case 'customerManage/resignationsLinkName/show.vue':
        //   this.goLog('resignationsLinkName')
        //   break
        case 'purchase/supplier/supplierLink/show.vue':
          this.goLog('linkman')
          break
        case 'financialManage/advance/show.vue':
          this.goLog('prePayment')
          break
        default:
          break
      }
    },
    isObject () {
      return typeof this.form === 'object' && this.form !== null
    },
    goLog (type) {
      let params = {}
      if (this.isObject()) {
        params = {
          serviceType: type,
          serviceId: `${this.form.id}`
        }
      } else {
        params = {
          serviceType: type,
          serviceId: `${this.form}`
        }
      }
      this.publicLogDias.visible = true
      this.publicLogDias.title = '数据操作日志'
      this.$refs.publicLogDiasRef.getLog(params)
    },
    publicLogDiasCancel () {
      this.publicLogDias.visible = false
    },
    publicLogDiasSucc () {
      this.publicLogDias.visible = false
    },
    handleSuccuse (data) {
      // console.log(data, '--------------', this.form, this.arr[0].data.id)
      let id = this.arr[0].data.id ? this.arr[0].data.id : data // 避免详情页层次过深导致id错误
      this.publicDias.visible = false
      this.isVisible = false
      this.$emit('editClick', id)
      // this.form = data
      // this.setForm(data, '')
    },
    // 0 展示   1 隐藏
    isButtonShowFun (isButtonShow) {
      if (isButtonShow === 0) this.isButtonShow = true
      else if (isButtonShow === 1) this.isButtonShow = false
    },
    publicDialogSucc () {
      this.publicDias.visible = false
    },
    publicDialogCancel () {
      this.publicDias.visible = false
    },
    handleEdit () {
      this.publicDrawerEdit()
    },
    publicDrawerEdit () {
      // paymentType 0预支 1预付
      // console.log(this.titles, this.componentNames, 'this.titles', this.form, this.arr)
      switch (this.titles) {
        case this.$tree([], 'financialManage/prepayment/index'):
        case this.$tree([], 'financialManage/advance/index'):
        case '预支预付':
          if (this.form.paymentType === 0) {
            this.publicEditDialogClick('费用预支', 'financialManage/advance/addEdit.vue')
          } else if (this.form.paymentType === 1) {
            this.publicEditDialogClick('项目预付', 'financialManage/advance/addEdit.vue')
          }
          break
        case this.$tree([], 'assetInformation/assetRegistration/index'):
          this.publicEditDialogClick(this.$tree([], 'assetInformation/assetRegistration/index'), 'assetInformation/assetRegistration/addEdit.vue')
          break
        case this.$tree([], 'financialManage/expenseReim/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/expenseReim/index'), 'financialManage/expenseReim/addEdit.vue')
          break
        case this.$tree([], 'purchase/purchaseRequest/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/purchaseRequest/index'), 'purchase/purchaseRequest/addEdit.vue')
          break
        case this.$tree([], 'financialManage/ticketReceiptRecord/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/ticketReceiptRecord/index'), 'financialManage/ticketReceiptRecord/addEdit.vue')
          break
        case this.$tree([], 'financialManage/billingRecords/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/billingRecords/index'), 'financialManage/billingRecords/addEdit.vue')
          break
        case this.$tree([], 'contractManage/paymentPlan/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/paymentPlan/index'), 'contractManage/paymentPlan/addEdit.vue')
          break
        case this.$tree([], 'contractManage/paymentRecord/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/paymentRecord/index'), 'contractManage/paymentRecord/addEdit.vue')
          break
        case this.$tree([], 'purchase/paymentSchedule/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/paymentSchedule/index'), 'purchase/paymentSchedule/addEdit.vue')
          break
        case this.$tree([], 'purchase/paymentRecords/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/paymentRecords/index'), 'purchase/paymentRecords/addEdit.vue')
          break
        case this.$tree([], 'offices/courtesyApplication/index'):
          this.publicEditDialogClick(this.$tree([], 'offices/courtesyApplication/index'), 'offices/courtesyApplication/addEdit.vue')
          break
        case this.$tree([], 'system/notice/index'):
          this.publicEditDialogClick(this.$tree([], 'system/notice/index'), 'system/notice/NaticeAdd.vue')
          break
        case this.$tree([], 'financialManage/largeAmountApplication/index'):
          this.publicEditDialogClick(this.$tree([], 'financialManage/largeAmountApplication/index'), 'financialManage/largeAmountApplication/addEdit.vue')
          break
        case this.$tree([], 'purchase/supplier/supplierLink/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/supplier/supplierLink/index'), 'purchase/supplier/supplierLink/addEdit.vue')
          break
        case this.$tree([], 'customerManage/linkName/index'):
          this.publicEditDialogClick(this.$tree([], 'customerManage/linkName/index'), 'customerManage/linkName/addEdit.vue')
          break
        case this.$tree([], 'projectManage/humanCost/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/humanCost/index'), 'projectManage/humanCost/addEdit.vue')
          break
        case this.$tree([], 'projectManage/projectProposals/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/projectProposals/index'), 'projectManage/projectProposals/addEdit.vue')
          break
        case this.$tree([], 'purchase/productManage/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/productManage/index'), 'purchase/productManage/addEdit.vue')
          break
        case this.$tree([], 'projectManage/fundCost/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/fundCost/index'), 'projectManage/fundCost/addEdit.vue')
          break
        case this.$tree([], 'offices/operatingCosts/index'):
          this.publicEditDialogClick(this.$tree([], 'offices/operatingCosts/index'), 'offices/operatingCosts/addEdit.vue')
          break
        case this.$tree([], 'projectManage/laborAndMaterial/index'):
          this.publicEditDialogClick(this.$tree([], 'projectManage/laborAndMaterial/index'), 'projectManage/laborAndMaterial/addEdit.vue')
          break
        case this.$tree([], 'inventory/transferWarehouses/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/transferWarehouses/index'), 'inventory/transferWarehouses/addEdit.vue')
          break
        case this.$tree([], 'inventory/outStock/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/outStock/index'), 'inventory/outStock/addEdit.vue')
          break
        case this.$tree([], 'inventory/informationSettings/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/informationSettings/index'), 'inventory/informationSettings/addEdit.vue')
          break
        case this.$tree([], 'inventory/takeItBack/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/takeItBack/index'), 'inventory/takeItBack/addEdit.vue')
          break
        case this.$tree([], 'inventory/storageReceipt/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/storageReceipt/index'), 'inventory/storageReceipt/addEdit.vue')
          break
        case this.$tree([], 'customerManage/resignationsLinkName/index'):
          this.publicEditDialogClick(this.$tree([], 'customerManage/resignationsLinkName/index'), 'customerManage/resignationsLinkName/addEdit.vue')
          break
        case this.$tree([], 'customerManage/resignationsCompensation/index'):
          this.publicEditDialogClick(this.$tree([], 'customerManage/resignationsCompensation/index'), 'customerManage/resignationsCompensation/addEdit.vue')
          break
        case this.$tree([], 'purchase/purchRefundRec/index'):
          this.publicEditDialogClick(this.$tree([], 'purchase/purchRefundRec/index'), 'purchase/purchRefundRec/addEdit.vue')
          break
        case this.$tree([], 'inventory/prodTransRec/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/prodTransRec/index'), 'inventory/prodTransRec/addEdit.vue')
          break
        case this.$tree([], 'inventory/returnWarehouse/index'):
          this.publicEditDialogClick(this.$tree([], 'inventory/returnWarehouse/index'), 'purchase/purchaseNote/sendBack.vue')
          break
        case '销售资源':
          this.publicEditDialogClick('销售资源', 'salesOpportunities/ProjectResourcePool/addEdit.vue')
          break
        case this.$tree([], 'contractManage/contractManagement/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/contractManagement/index'), 'contractManage/contractManagement/addEdit.vue')
          break
        case this.$tree([], 'manpower/recruitmentDemand/index'):
          this.publicEditDialogClick(this.$tree([], 'manpower/recruitmentDemand/index'), 'manpower/recruitmentDemand/addEdit.vue')
          break
        case this.$tree([], 'contractManage/earnestMoney/index'):
          this.publicEditDialogClick(this.$tree([], 'contractManage/earnestMoney/index'), 'contractManage/earnestMoney/addEdit.vue')
          break
        default:
          break
      }
      switch (this.componentNames) {
        case 'inventory/takeItBack/details.vue':
          this.publicEditDialogClick('领用单', 'inventory/takeItBack/addEdit.vue')
          break
        default:
          break
      }
    },
    publicEditDialogClick (title, path) { // 编辑
      this.publicDias.visible = true
      if (title === this.$tree([], 'financialManage/prepayment/index') || title === this.$tree([], 'financialManage/advance/index')) {
        this.publicDias.title = '[修改]' + title
      } else {
        this.publicDias.title = '[编辑]-' + title
      }
      this.publicDias.comName = path
      this.$refs.publicEditDialogRef.edit(this.form)
    },
    // handleAuth (e) {
    //   if (e.indexOf(this.nowUserName) !== -1) {
    //     this.isButtonShow = true
    //   } else {
    //     this.handleSwich()
    //   }
    // },
    setForm (form, val, arr, recycleBinShow) {
      this.recycleBinShow = recycleBinShow
      // this.isVisible = true
      // console.log(form, 'form', this.authList)
      if (arr && arr.length > 0) {
        if (arr.indexOf(this.nowUserName) !== -1) {
          this.isButtonShow = true
        } else {
          this.handleSwich()
        }
      } else {
        this.handleSwich()
      }
      this.titles = this.title
      this.componentNames = this.componentName
      this.form = form
      this.arr.push({ data: form, componentName: this.componentNames, titles: this.titles })
    },
    handleSwich () { // 编辑权限
      switch (this.titles) {
        case this.$tree([], 'financialManage/prepayment/index'):
        case this.$tree([], 'financialManage/advance/index'):
        case '预支预付':
          this.handleIsShow('prePayment:update')
          break
        case this.$tree([], 'assetInformation/assetRegistration/index'):
          this.handleIsShow('fixAssetManagement:update')
          break
        case this.$tree([], 'financialManage/expenseReim/index'):
          this.handleIsShow('reimbursement:update')
          break
        case this.$tree([], 'purchase/purchaseRequest/index'):
          this.handleIsShow('purchaseRequisition:update')
          break
        case this.$tree([], 'financialManage/ticketReceiptRecord/index'):
          this.handleIsShow('invoice:update')
          break
        case this.$tree([], 'financialManage/billingRecords/index'):
          this.handleIsShow('invoice:update')
          break
        case this.$tree([], 'contractManage/paymentPlan/index'):
          this.handleIsShow('payBack:update')
          break
        case this.$tree([], 'contractManage/paymentRecord/index'):
          this.handleIsShow('payBack:update')
          break
        case this.$tree([], 'purchase/paymentSchedule/index'):
          this.handleIsShow('payPlan:update')
          break
        case this.$tree([], 'purchase/paymentRecords/index'):
          this.handleIsShow('payPlan:update')
          break
        case this.$tree([], 'offices/courtesyApplication/index'):
          this.handleIsShow('festivalGift:update')
          break
        case this.$tree([], 'system/notice/index'):
          this.handleIsShow('notice:update')
          break
        case this.$tree([], 'financialManage/largeAmountApplication/index'):
          this.handleIsShow('bigAmount:update')
          break
        case this.$tree([], 'purchase/supplier/supplierLink/index'):
        case this.$tree([], 'customerManage/linkName/index'):
          this.handleIsShow('linkman:update')
          break
        case this.$tree([], 'projectManage/humanCost/index'):
          this.handleIsShow('humanCost:update')
          break
        case this.$tree([], 'projectManage/projectProposals/index'):
          this.handleIsShow('projectApproval:update')
          break
        case this.$tree([], 'purchase/productManage/index'):
          this.handleIsShow('product:update')
          break
        case this.$tree([], 'projectManage/fundCost/index'):
          this.handleIsShow('fundCost:update')
          break
        case this.$tree([], 'offices/operatingCosts/index'):
          this.handleIsShow('operatingCosts:update')
          break
        case this.$tree([], 'projectManage/laborAndMaterial/index'):
          this.handleIsShow('fixAssetManagement:update')
          break
        case this.$tree([], 'inventory/transferWarehouses/index'):
          this.handleIsShow('stockAllot:update')
          break
        case this.$tree([], 'inventory/outStock/index'):
          this.handleIsShow('stockOut:update')
          break
        case this.$tree([], 'inventory/informationSettings/index'):
          this.handleIsShow('stock:update')
          break
        case this.$tree([], 'inventory/takeItBack/index'):
          this.handleIsShow('stockReceive:update')
          break
        case this.$tree([], 'inventory/storageReceipt/index'):
          this.handleIsShow('stockIn:update')
          break
        case this.$tree([], 'inventory/returnWarehouse/index'):
          this.handleIsShow('stockToback:update')
          break
        case this.$tree([], 'manpower/recruitmentDemand/index'):
          this.handleIsShow('recruitment:update')
          break
        case this.$tree([], 'contractManage/earnestMoney/index'):
          this.handleIsShow('earnestMoney:update')
          break
        default:
          break
      }
      switch (this.componentNames) {
        case 'inventory/takeItBack/details.vue':
          this.handleIsShow('stockReceive:update')
          break
        default:
          break
      }
    },
    handleIsShow (e) {
      if (this.authList.indexOf(e) === -1) this.isButtonShow = false
    },
    goNoteClick () {
      this.loadings = true
      setTimeout(() => {
        this.loadings = false
      }, 200)
      this.arr.pop()
      let item = this.arr[this.arr.length - 1]
      this.datasChange(item.data, item.componentName, item.titles, 0)
    },
    onLoadView () {
      if (this.arr.length <= 1) {
        this.loadings = false
        this.$refs.componentRef.setFormData(this.form, this.recycleBinShow)
      }
    },
    projectChange (value, name, id) {
      this.$emit('projectChanges', value, name, id)
    },
    detailClickOutwork (dataVal, componentName, titleVal, numVal) {
      this.loadings = true
      setTimeout(() => {
        this.loadings = false
      }, 200)
      this.titles = titleVal
      if (titleVal === this.$tree([], 'offices/travelRecords/index')) this.isButtonShow = false
      this.componentNames = componentName
      this.form = dataVal
      if (numVal !== 0) {
        this.arr.push({ data: dataVal, componentName: componentName, titles: titleVal })
      }
      // setTimeout(() => {
      //   this.loadings = false
      //   this.$nextTick(() => {
      //     this.$refs.componentRef.setFormData(dataVal)
      //   })
      // }, 200)
    },
    datasChange (data, componentName, title, num) {
      // console.log(data, componentName, title, num, 'copyDrawer')
      this.loadings = true
      this.form = data
      setTimeout(() => {
        this.loadings = false
      }, 200)
      this.componentNames = componentName
      this.titles = title
      // console.log(componentName, 'componentNames')
      if (componentName === 'customerManage/resignationsCompensation/detail.vue') {
        this.isButtonShow = false
      } else if (componentName === 'financialManage/advance/show.vue' || componentName === 'customerManage/resignationsLinkName/show.vue') {
        this.isButtonShow = true
      }
      if (title === this.$tree([], 'offices/travelRecords/index')) this.isButtonShow = false
      if (num !== 0) {
        this.arr.push({ data: data, componentName: componentName, titles: title })
      }
      setTimeout(() => {
        if (this.$refs.componentRef) {
          if (title === `${this.$tree([], 'inventory/outStock/index')}详情`) {
            this.$refs.componentRef.setFormData(data.id)
            this.isButtonShow = false
          } else {
            this.$refs.componentRef.setFormData(data)
          }
        }
      }, 200)
    },
    handleCancel () {
      this.reset()
      this.$emit('close')
    },
    reset () {
      this.titles = ''
      this.componentNames = ''
      this.form = {}
      this.arr = []
    }
  }
}
</script>
<style lang="less" scoped>
// .close {
//   position: absolute;
//   right: 20px;
// }
.edit {
  position: absolute;
  right: 120px;
}
.log {
  position: absolute;
  right: 190px;
}
/deep/ .ant-drawer {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.spin-content {
  // border: 1px solid #91d5ff;
  // background-color: #e6f7ff;
  padding: 30px;
}
/deep/ .ant-drawer-header {
  position: sticky; /* 粘性定位 */
  top: 0;
  z-index: 1000;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/deep/ .ant-drawer-body {
  overflow-y: auto; /* 允许内容滚动 */
  height: calc(100vh - 55px); /* 减去标题栏高度 */
  &::-webkit-scrollbar {
    /* Chrome/Safari/Edge */
    width: 0;
    background: transparent;
  }
}

.close {
  position: absolute !important; /* 强制固定定位 */
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/copyDrawer.vue